var exports = {
  "p": "ChannelWelcomeSection.module__channelIcon___OXVuTE",
  "kL": "ChannelWelcomeSection.module__container___OXVuTE",
  "R_": "ChannelWelcomeSection.module__heading___OXVuTE",
  "h_": "ChannelWelcomeSection.module__description___OXVuTE",
  "RK": "ChannelWelcomeSection.module__iconSize___OXVuTE",
};

module.exports = exports;
